// Extracted from the route's `beforeLoad` so a unit test can reach every deny
// path without a router. Hiding the nav entry is not a gate: the URL is direct.

import { redirect } from '@tanstack/react-router';

export function assertDancerProfilesEnabled(
	flags: Record<string, boolean>,
): void {
	if (!flags['dancer-profiles']) {
		throw redirect({ to: '/live-in-club' });
	}
}

// A FAILED evaluation is a dark flag, not an error boundary: a broken flag
// service must neither strand the Manager nor open the surface.
export async function gateDancersRoute(
	fetchFlags: () => Promise<Record<string, boolean>>,
): Promise<void> {
	let flags: Record<string, boolean>;
	try {
		flags = await fetchFlags();
	} catch {
		throw redirect({ to: '/live-in-club' });
	}
	assertDancerProfilesEnabled(flags);
}
